import {KeyInformationLazy} from 'app/components/keyInformation/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineKeyInformation(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-key-information')) {
        return;
    }

    class GemKeyInformation extends WebComponentLoader {
        reactLazyComponent = KeyInformationLazy;
    }

    customElements.define('gem-key-information', GemKeyInformation);
}
